import React from 'react';
import MetaTitle from '../src/common/component/MetaTitle';
import {IS_CLIENT} from '../src/common/constant';
import {Page} from '../src/common/constant/page';
import {getMetaTitle} from '../src/common/function';
import useTypedSelector from '../src/common/hook/useTypedSelector';
import {IKwPage} from '../src/common/type';
import {redirectTo} from '../src/common/util/PageRouter';
import Event from '../src/event/container/Event';
import {actions} from '../src/event/state/action';

interface IProps {
  eventId: number;
}

interface IQuery {
  event_id: string;
}

const EventStaticPage: IKwPage<IProps, IQuery> = ({eventId}) => {
  const eventPageTitle = useTypedSelector(
    state => state.event.moduleMap.event?.commonModule.eventTitle || ''
  );
  return (
    <>
      <MetaTitle page={Page.Event} title={getMetaTitle(eventPageTitle)} />
      <Event key={eventId} eventId={eventId} />
    </>
  );
};

EventStaticPage.getInitialProps = ({store, query, res}) => {
  const eventId = Number(query.event_id);

  if (isNaN(eventId) || !eventId) {
    redirectTo({pageInfo: '/404', res});
    return {} as any;
  }

  const _eventId = store.getState().event.eventId;
  _eventId &&
    eventId !== _eventId &&
    store.dispatch(actions.setEventModuleMap({}));

  !IS_CLIENT && store.dispatch(actions.fetchEventModuleMap('event', eventId));
  return {eventId};
};

EventStaticPage.initialPageProps = {
  page: Page.Event,
  getPageTitle: () => '',
};

export default EventStaticPage;
